export default __webpack_public_path__ + "a110b503f24b7cc59ae7b12ae57bfdf2.svg";